import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__tLVip","info":"styles_info__Sw+9l","error":"styles_error__bYc0X","success":"styles_success__4m0Sf","warning":"styles_warning__394X+","invert":"styles_invert__+bIJn","arrow":"styles_arrow__JQPFp"};
export const b = b_.with('tooltip');